var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{class:_vm.$style.header},[_c('a',{class:_vm.$style.headerLink,attrs:{"href":"https://jumpcloud.com"}},[_c('LogoIcon',{class:_vm.$style.logoIcon,attrs:{"fixed":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }